// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"652":"0b6c5f61","724":"384a90da"}[chunkId] + ".css";
};